module.exports = __webpack_public_path__ + "img/img_market_con7.64945e17.png";